import {createFeatureSelector, createSelector} from '@ngrx/store';
import {EState} from 'src/app/state/reducers';
import {ICancelOrderState} from '../models/cancel-order-state.model';
import {ICheckoutState} from '../models/checkout.state.model';
import {IConsentPdfState} from '../models/consent-pdf-state.model';

export const selectCheckoutState = createFeatureSelector<ICheckoutState>(EState.Checkout);

export const selectOrderForm = createSelector(
  selectCheckoutState,
  (selectCheckoutState: ICheckoutState) => selectCheckoutState?.orderFormData
);

export const selectCustomerOrganization = createSelector(
  selectCheckoutState,
  (selectCheckoutState: ICheckoutState) => selectCheckoutState?.selectedOrganization
);

export const selectCheckoutStatus = createSelector(
  selectCheckoutState,
  (selectCheckoutState: ICheckoutState) => selectCheckoutState?.checkoutStatus
);

export const selectConsentPdfState = createFeatureSelector<IConsentPdfState>(EState.ConsentPdf);

export const selectOrderStep = createSelector(
  selectCheckoutState,
  (selectCheckoutState: ICheckoutState) => selectCheckoutState?.orderData?.lastCompletedStep ?? 0
);

export const selectOrderData = createSelector(
  selectCheckoutState,
  (selectCheckoutState: ICheckoutState) => selectCheckoutState?.orderData
);

export const selectCancelOrder = createFeatureSelector<ICancelOrderState>(EState.CancelOrder);

export const selectOrderStatus = createSelector(
  selectCheckoutState,
  (selectCheckoutState: ICheckoutState) => selectCheckoutState?.status
);

export const selectSampleTypes = createSelector(
  selectCheckoutState,
  (checkoutState: ICheckoutState) => checkoutState.sampleTypes
);

export const selectPatientRelationTypes = createSelector(
  selectCheckoutState,
  (checkoutState: ICheckoutState) => checkoutState.patientRelationTypes
);
